import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { LitElement as r, html as o } from "lit";
import { property as i } from "lit/decorators.js";
import n from "@inera/ids-design/components/button-group/button-group-lit.js";
var p, u, l, a;
class f extends r {
  constructor() {
    super(...arguments), p.set(this, !1), u.set(this, "start"), l.set(this, !1), a.set(this, "m");
  }
  get rtl() {
    return e(this, p, "f");
  }
  set rtl(t) {
    s(this, p, t, "f");
  }
  get justify() {
    return e(this, u, "f");
  }
  set justify(t) {
    s(this, u, t, "f");
  }
  get unresponsive() {
    return e(this, l, "f");
  }
  set unresponsive(t) {
    s(this, l, t, "f");
  }
  get break() {
    return e(this, a, "f");
  }
  set break(t) {
    s(this, a, t, "f");
  }
  render() {
    return o`<div class="ids-button-group ids-button-group--break-${this.break} ids-button-group--${this.justify} ${this.rtl ? "ids-button-group--rtl" : ""} ${this.unresponsive ? "ids-button-group--unresponsive" : ""}"><slot></slot></div>`;
  }
}
p = new WeakMap(), u = new WeakMap(), l = new WeakMap(), a = new WeakMap(), f.styles = [n], t([i({
  type: Boolean
})], f.prototype, "rtl", null), t([i({
  type: String
})], f.prototype, "justify", null), t([i({
  type: Boolean,
  reflect: !0
})], f.prototype, "unresponsive", null), t([i({
  type: String,
  reflect: !0
})], f.prototype, "break", null);
export { f as IDSButtonGroup };